import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { SiTicktick } from "react-icons/si";

const OngoingOrders = ({ ongoingOrders ,setSelectedOngoingOrder,setOrderId ,displayReceiveConfirmation  ,setDisplayReceiveConfirmation}) => {
  const navigate = useNavigate();
  const [width, setWidth] = useState(window.innerWidth);

  useEffect(() => {
    const resizeHandler = () => setWidth(window.innerWidth);
    window.addEventListener("resize", resizeHandler);

    return () => {
      window.removeEventListener("resize", resizeHandler);
    };
  }, []);

  return (
    <div className="flex flex-col divide-y divide-gray-100 bg-white shadow-sm overflow-hidden">
      {ongoingOrders?.map((order, index) => {
        const mailTime = new Date(order?.orderedAt).getTime();
        const isNew = Date.now() - mailTime < 30 * 1000; // Highlight new order

        return (
          <div key={index}>
          
            {width > 640 ? (
              <div>
              <div
                className={`flex sm:grid sm:grid-cols-5 gap-2 sm:gap-4 px-4 sm:px-6 py-3 sm:py-3 transition-all duration-300 hover:bg-gradient-to-r hover:from-blue-50 hover:to-indigo-50 hover:shadow-md rounded-none cursor-pointer hover:border-l-4 border-transparent hover:border-blue-400 ${
                  isNew ? "animate-bg-pulse bg-blue-50/30" : ""
                }`}
                 onClick={() =>{
              setSelectedOngoingOrder(order);
            }}
              >
                {/* 1. Shop Name */}
                <div className="flex items-center gap-3 sm:justify-center">
                  <div className="flex flex-col truncate capitalize text-[0.7rem]">
                    <span className="text-[0.9rem] font-normal text-gray-800 truncate">
                      Anand Enterprises
                    </span>
                    <span className="text-[0.8rem] text-gray-500 truncate font-light">
                      Bvimr basement
                    </span>
                  </div>
                </div>

                {/* 2. Price */}
                <div className="text-center text-[0.9rem] font-normal flex items-center justify-center text-green-600">
                  ₹{order?.price ?? "Loading..."}  <SiTicktick size={17} className=" ml-2 text-green-600 inline"/>
                </div>

                {/* 3. Date & Time */}
                <div className="text-center text-[0.75rem] text-gray-500 flex items-center justify-center group-hover:text-gray-700 font-normal">
                  {new Date(order?.orderedAt).toLocaleDateString("en-GB", {
                    day: "2-digit",
                    month: "short",
                    year: "2-digit",
                  })}
                  ,{" "}
                  {new Date(order?.orderedAt).toLocaleTimeString("en-US", {
                    hour: "2-digit",
                    minute: "2-digit",
                    hour12: true,
                  })}
                </div>

                      {/* 4. OTP */}
                <div className="text-center text-[0.9rem] flex items-center justify-center text-black-600 font-semibold">
                  {order?.otp ?? "Loading..."}
                </div>

                {/* 5. Prints Ready In */}
                <div className="text-center text-[0.9rem] flex items-center justify-center text-orange-600">
                  <span className={` ${order?.orderStatus==="completed" ? 'text-green-600 bg-green-100' : 'text-yellow-600 bg-yellow-100'} px-2 py-1 rounded-full text-sm font-normal`}>
                      {
                        order?.orderStatus === "completed" ? "Come for pickup"
                      :  (order?.remainingTime!==undefined && order?.remainingTime!==NaN) && order?.orderedAt
                          ? Math.max(
                              2,
                              Math.ceil(order.remainingTime - (Date.now() - new Date(order.orderedAt).getTime()) / 60000)
                            ) + " mins"
                          : "--"
                      }
                  </span>
                </div>
              </div>
              {
                    order?.orderStatus==="completed" ? <div className="text-[0.65rem] text-gray-500 mt-1 text-center bg-gray-200 pt-1 hover:bg-gray-300"
                                                        onClick={()=>{setOrderId(order?.orderId); setDisplayReceiveConfirmation(true)}}>
                      Please tap here to receive the order.
                  </div> :
                  <div></div>
              }
            </div>
            ) : (
              <div>
              <div
                key={order?.orderId || index}
                className={`group relative transition-all duration-300 hover:bg-gradient-to-r hover:from-blue-50 hover:to-indigo-50 hover:shadow-md cursor-pointer border-l-4 border-transparent hover:border-blue-400 active:scale-[0.98] ${
                  isNew ? "animate-bg-pulse bg-blue-50/30 border-l-blue-400" : ""
                }`}
                onClick={() =>{
                  setSelectedOngoingOrder(order);
                }}
              >
                <div className="p-3 space-y-1">
                  {/* Header Section */}
                  <div className="flex justify-between items-start">
                    <div className="flex-1 min-w-0">
                      <div className="flex items-center gap-2 mb-1">
                        {/* Shop Details */}
                        <div className="min-w-0 flex flex-col">
                          <h3 className="text-[0.85rem] sm:text-sm font-normal text-gray-900 truncate">
                            Anand Enterprises
                          </h3>
                          <p className="text-[0.75rem] sm:text-xs text-gray-500 truncate">
                            Bvimr basement
                          </p>
                        </div>
                      </div>
                    </div>
                    
                    {/* Price Badge */}
                    <div className="ml-3 flex-shrink-0">
                      <div className="px-2 py-1">
                        <div className="text-green-700 font-semibold flex gap-4 text-sm">
                          <span>₹{order?.price ?? " Loading..."} <SiTicktick size={17} className=" ml-1 text-green-600 inline"/></span>
                          <span className="ml-2 ">{order?.otp ?? "-"}</span>
                        </div>
                      </div>
                    </div>
                  </div>

            

                  {/* Status Section */}
                  <div className={`${order?.orderStatus === "completed" ? "bg-green-100" : "bg-yellow-100"}  p-1 space-y-1 rounded-[10px] px-2`}>
                    <div className="flex items-center justify-start">
                      <div className="flex items-center gap-2">
                        <div className="w-2 h-2 bg-yellow-400 rounded-full animate-pulse"></div>
                        <p className="text-xs font-medium text-gray-600">
                          <span className={`${order?.orderStatus === "completed" ? 'text-green-600 bg-green-100' : 'text-yellow-600 bg-yellow-100'} px-2 py-1 rounded-full text-sm font-normal`}>
                            {order?.orderStatus === "completed" 
                              ? "Come for pickup"
                              : (order?.remainingTime!==undefined && order?.remainingTime!==NaN) && order?.orderedAt
                                ? "Ready in " + Math.max(
                                    2,
                                    Math.ceil(order.remainingTime - (Date.now() - new Date(order.orderedAt).getTime()) / 60000)
                                  ) + " mins"
                                : "Ready in --"
                            }
                          </span>
                        </p>
                      </div>
                      
                    </div>
                  </div>

                  {/* Footer Section */}
                  <div className="flex justify-between items-center pt-2 border-t border-gray-100">
                    <div className="flex items-center gap-2">
                      {/* Clock Icon */}
                      <div className="w-4 h-4 text-blue-400">
                        <svg fill="currentColor" viewBox="0 0 20 20">
                          <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm1-12a1 1 0 10-2 0v4a1 1 0 00.293.707l2.828 2.829a1 1 0 101.415-1.415L11 9.586V6z" clipRule="evenodd" />
                        </svg>
                      </div>
                      <span className="text-[0.65rem] sm:text-xs text-gray-500 font-semibold">
                        Ordered at {" "}
                        
                        {new Date(order?.orderedAt).toLocaleTimeString("en-US", {
                          hour: "2-digit",
                          minute: "2-digit",
                          hour12: true,
                        })}
                        {" ("}
                        {new Date(order?.orderedAt).toLocaleDateString("en-GB", {
                          day: "2-digit",
                          month: "short",
                          year: "2-digit",
                        })} 
                        {") "}
                        
                      </span>
                    </div>
                    
                    {/* New Order Indicator */}
                    {isNew && (
                      <div className="flex items-center gap-1">
                        <div className="w-2 h-2 bg-blue-500 rounded-full animate-pulse"></div>
                        <span className="text-xs font-semibold text-blue-600">NEW</span>
                      </div>
                    )}
                    
                    {/* Arrow Icon */}
                    <div className="w-4 h-4 text-gray-400 group-hover:text-blue-500 transition-colors">
                      <svg fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
                      </svg>
                    </div>
                    
                  </div>
                  
                  
                </div>
                
              </div>
              {
                    order?.orderStatus==="completed" ? <div className="text-[0.65rem] text-gray-500 mt-1 text-center bg-gray-200 pt-1 hover:bg-gray-300"
                                                        onClick={()=>{setOrderId(order?.orderId) ; setDisplayReceiveConfirmation(true)}}>
                      Please tap here to receive the order.
                  </div> :
                  <div></div>
              }
              </div>
            )}
          </div>
        );
      })}
    </div>
  );
};

export default OngoingOrders;